<div class="top-up-amount">
    <vl-title tag-name="h2">Op te laden bedrag</vl-title>
    <aeg-field-validation-wrapper :error-message="errors.amount" name="Op te laden bedrag"
                                  mod-hidden-label mod-required #default="{hasErrors}">
        <vl-input-group>
            <vl-input-addon :class="{'vl-input-field--error': hasErrors }" tooltip="In euro" text="€"/>
            <vl-input-field :mod-error="hasErrors" type="text" name="Saldo" id="saldo"
                            v-model="amount" v-bind="amountProps" pattern="[0-9]*[,.]?[0-9]*" />
        </vl-input-group>
    </aeg-field-validation-wrapper>
</div>
